import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
export default {
  props: {
    showOperation: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dropList: [{
        value: 'PersonalCenter',
        label: '个人中心'
      }, {
        value: 'OrderCenter',
        label: '订单中心'
      }, {
        value: 'VehicleCenter',
        label: '车辆中心'
      }, {
        value: 'InvoiceCenter',
        label: '发票中心'
      }],
      activated: 'PersonalCenter'
    };
  },
  methods: {
    handleRouterTo(name) {
      this.activated = name;
      this.$router.push({
        name: 'userCenter',
        params: {
          name
        }
      });
    },
    toLogin() {
      this.$router.push('/login');
    },
    handleLogout() {
      this.$utils.removeLocalStorage('userInfo');
      this.$utils.removeLocalStorage('token');
      this.$store.commit('changeLoginStatus');
      if (this.$route.meta) {
        this.$utils.toHome();
      }
    }
  },
  computed: {
    activatedLabel() {
      const name = this.$route.params.name;
      const result = this.dropList.find(_ => _.value === name);
      return result ? result.label : '个人中心';
    }
  },
  mounted() {
    /**
      */
  }
};